import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'

export const useEventosStore = defineStore('eventos', () => {
  const eventos = ref([])
  const loading = ref(false)

  async function fetchAll() {
    loading.value = true
    try {
      const { data } = await api.get('/eventos')
      eventos.value = data.eventos
    } finally { loading.value = false }
  }

  async function getOne(id) {
    const { data } = await api.get(`/eventos/${id}`)
    return data.evento
  }

  async function create(payload) {
    const { data } = await api.post('/eventos', payload)
    eventos.value = [data.evento, ...eventos.value]
    return data.evento
  }

  async function update(id, payload) {
    const { data } = await api.patch(`/eventos/${id}`, payload)
    eventos.value = eventos.value.map(e => e.id === id ? { ...e, ...data.evento } : e)
    return data.evento
  }

  async function archive(id) {
    await api.delete(`/eventos/${id}`)
    eventos.value = eventos.value.map(e => e.id === id ? { ...e, status: 'ARQUIVADO' } : e)
  }

  return { eventos, loading, fetchAll, getOne, create, update, archive }
})
